import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookTransitInspectionTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          transit_inspection: [],
          st: '',
          flight_report_leg_id: '',
          transit_inspection_approval_date: '',
          transit_inspection_approval_user_id: '',
          transit_inspection_user_name: '',
        };
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(typeof newProps.transit_inspection !== 'undefined' && newProps.transit_inspection !== null && this.state.loaded === 0) {
          this.setState({
            transit_inspection: newProps.transit_inspection,
            st: newProps.transit_inspection.st,
            flight_report_leg_id: newProps.transit_inspection.flight_report_leg_id,
            transit_inspection_approval_date: newProps.transit_inspection.transit_inspection_approval_date,
            transit_inspection_approval_user_id: newProps.transit_inspection.transit_inspection_approval_user_id,
            transit_inspection_user_name: newProps.transit_inspection.transit_inspection_user_name,
          });
        }
      }
    
      render() {
        var self = this;
        return (
          <tr className="text-center" key={this.state.flight_report_leg_id}>
            <td>
              <input type="text" name="st" className="form-control text-center" value={this.state.st} disabled />
            </td>
            <td>
              <input type="text" name="transit_inspection_user_name" className="form-control text-center" value={this.state.transit_inspection_user_name} disabled />
            </td>
            <td>
              <input type="text" name="transit_inspection_approval_date" className="form-control text-center" value={this.state.transit_inspection_approval_date} disabled />
            </td>
            <td>
            {
              (this.state.transit_inspection_approval_date !== null) ?
              <button className="btn btn-block btn-success" disabled><i className="fa fa-check"> Inspeção de Trânsito Realizada</i></button>
              :
              <button onClick={() => {self.props.editTransitInspection(this.state.flight_report_leg_id)}} className="btn btn-block btn-success"><i className="fa fa-check"> Inspeção de Trânsito Realizada</i></button>
            }
            </td>
          </tr>
    );
  }
}

export default AircraftLogbookTransitInspectionTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookTransitInspectionTab.js